import styled, { css, keyframes } from 'styled-components';

import TextInput from '@components/FormInputs/TextInput';

const COLORS = {
  grey: '#a5a9b4',
  darkGrey: '#858585',
  disabledGrey: '#E0E0E0',
  buttonGreen: '#009688',
  buttonHoverGreen: '#01BEA4',
  lightGrey: '#616161',
  ligthRed: '#fb6f91',
  overlayDark: '#33333322',
  panelShadow: '#0000004D',
  primaryGreen: '#009688',
  white: '#ffffff',
  black: '#000000',
};

const animationIn = keyframes`
  0% { 
    right: 50px;
    opacity: 0; 
  }
  
  100% { 
    right: 0; 
    opacity: 1; 
  }
`;

export const Container = styled.div`
  animation: ${animationIn} 0.5s ease 0.5s forwards;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  opacity: 0;
  position: relative;
`;

export const ResponseInfo = styled.span`
  font-size: 24px;
  font-weight: bold;
  ${({ type }) =>
    type === 'error'
      ? css`
          color: ${COLORS.ligthRed};
        `
      : css`
          color: ${COLORS.primaryGreen};
        `}
`;

export const RequestContainer = styled.div`
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  background-color: #ffffffe1;
  z-index: 9999999999;
`;

export const Title = styled.span`
  width: 100%;
  font-size: 22px;
  font-weight: 700;
`;

export const SubTitle = styled.span`
  margin: 10px 0 30px 0;
  color: ${COLORS.grey};
  font-size: 1em;
  font-weight: 300;
`;

export const InputContent = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 15px;
  width: 100%;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  width: 100%;

  @media (min-width: 1024px) {
    margin-right: 30px;
    width: 70%;
  }
`;

export const InputRow = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;

  > div {
    padding-right: 20px;
  }

  input,
  textarea {
    width: 100%;
  }

  @media (min-width: 1024px) {
    flex-direction: row;
  }
`;

export const InputWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  > span {
    color: #e25959;
    font-size: 14px;
    font-weight: 600;
    margin-top: 5px;
    margin-left: 5px;
  }
`;

export const InputText = styled.input`
  width: 100%;
  height: 57px;
  margin-top: 20px;
  border-radius: 16px;
  border: 2px solid ${COLORS.disabledGrey};
  padding: 2px 23px 0;
  font-weight: 600;
  color: ${COLORS.black};
  transition: box-shadow 0.2s ease-out, border-color 0.2s ease-out;
  font-size: 16px;
`;

export const InputTextArea = styled.textarea`
  width: 100%;
  height: 57px;
  margin-top: 20px;
  border-radius: 16px;
  border: 2px solid ${COLORS.disabledGrey};
  padding: 2px 23px 0;
  font-weight: 600;
  color: ${COLORS.black};
  transition: box-shadow 0.2s ease-out, border-color 0.2s ease-out;
  font-size: 16px;
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  margin-right: 20px;
`;

export const CancelButton = styled.button`
  border-radius: 8px;
  background-color: ${COLORS.white};
  border: none;
  color: ${COLORS.primaryGreen};
  font-size: 15px;
  font-weight: 600;
  height: 47px;
  padding: 2px 41px 0;
  cursor: pointer;

  @media (min-width: 1024px) {
    margin-right: 30px;
  }
`;

export const UpdateButton = styled.button`
  border-radius: 8px;
  background-color: ${COLORS.primaryGreen};
  border: none;
  color: ${COLORS.white};
  font-size: 15px;
  font-weight: 600;
  height: 47px;
  padding: 2px 41px 0;
  cursor: pointer;
`;

export const Error = styled.span`
  color: ${COLORS.ligthRed};
  margin: 10px 0px 0px 10px;
  font-weight: 700;
  align-self: flex-start;
`;
